import zy0925Course from '@/assets/articles/zy0925-course.jpg';
import mueyeb22Whitening from '@/assets/articles/mueyeb22-whitening.jpg';
import macy8166Course from '@/assets/articles/macy8166-course.jpg';
import kikio717Brightening from '@/assets/articles/kikio717-brightening.jpg';
import weibaby0109Products from '@/assets/articles/weibaby0109-products.jpg';
import teresasky0622Brightening from '@/assets/articles/teresasky0622-brightening.jpg';
import xoxvov2000Course from '@/assets/articles/xoxvov2000-course.jpg';

export const ARTICLE_TABS = ['頂級鑽石光逆齡課程', '極緻白。嫩。澎。緊', '打造4D粉鑽逆齡奇肌'];
export const PAGE_SIZE = 9;

const createArticle = (title, link, image, author) => ({
    title,
    link,
    image,
    detail: {
        author: {
            name: author
        }
    }
});

const sharedArticles = {
    zy0925: createArticle(
        '克麗緹娜頂級鑽石光逆齡課程體驗，搭配粉紅鑽產品五件組開箱',
        'https://zy0925.pixnet.net/blog/post/356447896',
        zy0925Course,
        'zy0925'
    ),
    laurasweet0712: createArticle(
        '克麗緹娜頂級鑽石光逆齡課程，粉紅瓶與透白精華、提拉面膜一次整理',
        'https://laurasweet0712.pixnet.net/blog/post/221957479',
        xoxvov2000Course,
        'laurasweet0712'
    ),
    s107262000: createArticle(
        'CHLITINA粉紅鑽產品搭配淨鑽光透白系列，打造鑽石光亮白美肌',
        'https://s107262000.pixnet.net/blog/post/355786399',
        weibaby0109Products,
        's107262000'
    ),
    zj4cj86: createArticle(
        '克麗緹娜粉紅鑽五件組開箱，白嫩澎彈保養步驟一次看',
        'https://zj4cj86.pixnet.net/blog/post/341939613',
        mueyeb22Whitening,
        'zj4cj86'
    ),
    mueyeb22: createArticle(
        '克麗緹娜亮白首選粉紅鑽，打造鑽石光透亮肌膚',
        'https://mueyeb22.pixnet.net/blog/post/91558045',
        mueyeb22Whitening,
        'mueyeb22'
    ),
    macy8166: createArticle(
        '克麗緹娜頂級鑽石光逆齡課程體驗，板橋做臉保養推薦',
        'https://macy8166.pixnet.net/blog/post/341966301',
        macy8166Course,
        'macy8166'
    ),
    kikio717: createArticle(
        '克麗緹娜逆齡雙星體驗，粉紅鑽系列重現光采白皙',
        'https://kikio717.pixnet.net/blog/post/226450099-%E3%80%8C%E9%AB%94%E9%A9%97%E3%80%8D%E8%87%89%E9%83%A8%E4%BF%9D%E9%A4%8A%E6%8E%A8%E8%96%A6-%E5%85%8B%E9%BA%97%E7%B7%B9%E5%A8%9Cx%E7%B2%89%E7%B4%85%E9%91%BD%E7%B3%BB',
        kikio717Brightening,
        'kikio717'
    ),
    weibaby0109: createArticle(
        '克麗緹娜粉紅鑽產品與鑽石光亮白，逆齡保養重點分享',
        'https://weibaby0109.pixnet.net/blog/post/70686607',
        weibaby0109Products,
        'weibaby0109'
    ),
    teresasky0622: createArticle(
        '克麗緹娜粉紅鑽產品保養分享，養成鑽石光亮白肌',
        'https://teresasky0622.pixnet.net/blog/post/340408341',
        teresasky0622Brightening,
        'teresasky0622'
    ),
    b1991226: createArticle(
        '克麗緹娜頂級鑽石光透白課程體驗，養成璀璨美肌',
        'https://b1991226.pixnet.net/blog/post/335766537',
        macy8166Course,
        'b1991226'
    ),
    xoxvov2000: createArticle(
        '克麗緹娜頂級鑽石光逆齡課程搭配粉紅鑽五件組，夏日亮白保養推薦',
        'https://xoxvov2000.pixnet.net/blog/post/222047677',
        xoxvov2000Course,
        'xoxvov2000'
    )
};

export const ARTICLE_DATA_BY_TAB = {
    [ARTICLE_TABS[0]]: [
        sharedArticles.zy0925,
        sharedArticles.xoxvov2000,
        sharedArticles.laurasweet0712,
        sharedArticles.macy8166,
        sharedArticles.b1991226,
        sharedArticles.kikio717,
        sharedArticles.weibaby0109,
        sharedArticles.teresasky0622,
        sharedArticles.s107262000,
        sharedArticles.zj4cj86
    ],
    [ARTICLE_TABS[1]]: [
        sharedArticles.mueyeb22,
        sharedArticles.s107262000,
        sharedArticles.zj4cj86,
        sharedArticles.teresasky0622,
        sharedArticles.kikio717,
        sharedArticles.weibaby0109,
        sharedArticles.laurasweet0712,
        sharedArticles.zy0925,
        sharedArticles.xoxvov2000
    ],
    [ARTICLE_TABS[2]]: [
        sharedArticles.zy0925,
        sharedArticles.xoxvov2000,
        sharedArticles.laurasweet0712,
        sharedArticles.s107262000,
        sharedArticles.zj4cj86,
        sharedArticles.mueyeb22,
        sharedArticles.kikio717,
        sharedArticles.weibaby0109,
        sharedArticles.teresasky0622
    ]
};
